/**
 * Project - sonynetwork.fa2chat-nuro-multi
 *
 * @desc 動画メッセージ
 *
 * @author dvinhthai
 * @copyright Copyright 2023 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-card class="fc-video-message" :class="[messageClass]">
  <el-dropdown @command="doMenu" trigger="click" placement="bottom-start">
    <!--TODO アイコンおよびメニューボタンのデザインについては #95410 で対応-->
    <span class="file-name-wrapper">{{fileName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
    <el-dropdown-menu class="video-menu" slot="dropdown">
      <el-dropdown-item class="video-menu-item" command="openPreview">{{$t('動画を表示')}}</el-dropdown-item>
      <el-dropdown-item class="video-menu-item" command="download">{{$t('ダウンロード')}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</el-card>
</template>
<script>
import FcMessageUtil from '@/utils/FcMessageUtil'
import WindowUtil from '@/utils/WindowUtil'
import ServiceUtil from '@/utils/ServiceUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'

import {
  Card,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui'

export default {
  name: 'FcVideoMessage',
  components: {
    'el-card': Card,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo'
  ],
  data() {
    return {}
  },
  computed: {
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageClass() {
      return 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * ファイル名
     * @return {String}
     */
    fileName() {
      return this.messageInfo.attachFileName
    }
  },
  methods: {
    /**
     * メニュー処理
     * @param  {string} command
     */
    doMenu(command) {
      if (command === 'openPreview') {
        this.openPreview()
      } else if (command === 'download') {
        this.download()
      }
    },
    /**
     * 動画プレビューを開きます
     */
    openPreview() {
      let videoType = this.messageInfo.attachFileMimeType || ''
      if (this.messageInfo.attachFileMimeSubType != null) {
        videoType = videoType + '/' + this.messageInfo.attachFileMimeSubType
      }
      WindowUtil.openPreviewVideoWindow('findAttachContent?contentId=' + this.messageInfo.attachContentId, this.messageInfo.attachFileName, videoType)
    },
    /**
     * ファイルをダウンロードします。
     */
    download() {
      ServiceUtil.download('findAttachContent?contentId=' + this.messageInfo.attachContentId, this.messageInfo.attachFileName, this.emitUpdateDownloadStatus)
    },
    /**
     * Emit update download status
     */
    emitUpdateDownloadStatus() {
      if (this.messageInfo.distributionType !== MessageInfoConst.DISTRIBUTION_TYPE_FH_TO_FC) {
        return
      }
      this.$emit('updateDownloadStatus', this.messageInfo.attachContentId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcVideoMessage.vue